import { create } from 'zustand';
import api from '../services/api';

function carregarUsuario() {
  try {
    return JSON.parse(localStorage.getItem('usuario') || 'null');
  } catch {
    localStorage.removeItem('usuario');
    return null;
  }
}

const useAuthStore = create((set) => ({
  usuario: carregarUsuario(),

  login: (usuario) => {
    localStorage.removeItem('token');
    localStorage.setItem('usuario', JSON.stringify(usuario));
    set({ usuario });
  },

  logout: async () => {
    try { await api.post('/auth/logout'); } catch {}
    localStorage.removeItem('token');
    localStorage.removeItem('usuario');
    set({ usuario: null });
  },
}));

export default useAuthStore;
